export type Role =
  | 'planner'
  | 'designer'
  | 'regional-buyer'
  | 'country-buyer'
  | 'country-planner'
  | 'country-manager'
  | 'country-boss'
  | 'regional-manager'
  | 'regional-boss'
  | 'product-manager'
  | 'sar'
  | 'category-manager'
  | 'merchant'
  | 'supplier'
  | 'regional-analyst'
  | 'comex-country'
  | 'manager-udn'
  | 'packaging'
  | 'manager-visualizer'
  | 'packaging-manager';

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  status: number;
  CountryId: number;
  FollowGroupId: number;
  avatarUrl: string;
  businessUnit: string;
  role: Role;
  createdAt: Date;
  updatedAt: Date;
}

export function createMockUser(): User {
  return {
    id: 1,
    firstName: 'mock_first_name',
    lastName: 'mock_last_name',
    email: 'mock@email.com',
    status: 1,
    CountryId: null,
    avatarUrl: null,
    FollowGroupId: null,
    businessUnit: null,
    role: 'planner',
    createdAt: new Date(),
    updatedAt: new Date()
  };
}

export const Roles = {
  Planner: 'planner',
  Designer: 'designer',
  CountryBuyer: 'country-buyer',
  RegionalBuyer: 'regional-buyer',
  Comex: 'comex',
  Manager: 'manager',
  Admin: 'admin',
  CountryPlanner: 'country-planner',
  RegionalManager: 'regional-manager',
  CountryManager: 'country-manager',
  CountryBoss: 'country-boss',
  RegionalBoss: 'regional-boss',
  ProductManager: 'product-manager',
  Sar: 'sar',
  SupervisorQC: 'supervisor-qc',
  SuperAdmin: 'super-admin',
  CategoryManger: 'category-manager',
  Merchant: 'merchant',
  Supplier: 'supplier',
  RegionalAnalyst: 'regional-analyst',
  ManagerVisualizer: 'manager-visualizer',
  ComexCountry: 'comex-country',
  ManagerUdn: 'manager-udn',
  Packaging: 'packaging',
  PackagingManager: 'packaging-manager'
};

export const UserRolesMappings = {
  [Roles.Planner]: 'Planner',
  [Roles.Designer]: 'Diseñador',
  [Roles.RegionalBuyer]: 'Comprador regional',
  [Roles.CountryBuyer]: 'Comprador país',
  [Roles.CountryPlanner]: 'Planner país',
  [Roles.Comex]: 'Comex',
  [Roles.Manager]: 'Gerente',
  [Roles.Admin]: 'Administrador',
  [Roles.RegionalManager]: 'Gerente regional',
  [Roles.CountryManager]: 'Gerente país',
  [Roles.CountryBoss]: 'Jefe país',
  [Roles.RegionalBoss]: 'Jefe regional',
  [Roles.Sar]: 'Sar',
  [Roles.ProductManager]: 'Product manager',
  [Roles.SupervisorQC]: 'Supervisor QC',
  [Roles.SuperAdmin]: 'Usuario de lectura',
  [Roles.CategoryManger]: 'Category manager',
  [Roles.Merchant]: 'Merchant',
  [Roles.Supplier]: 'Supplier',
  [Roles.RegionalAnalyst]: 'Regional Analyst',
  [Roles.ManagerVisualizer]: 'Gerente Visualizador',
  [Roles.ComexCountry]: 'Comex país',
  [Roles.Packaging]: 'Packaging',
  [Roles.ManagerUdn]: 'Gerente U.D.N.',
  [Roles.PackagingManager]: 'Packaging Manager'
  // [Roles.Supplier]: 'Supplier'
};
